export default "__VITE_ASSET__695xjRIY__"